import React, { useContext } from 'react';

import * as S from './styles';
import Navbar from 'components/Navbar';
import NavTitleBar from 'components/NavTitleBar';
import LoginContext from 'context/LoginContext';

interface LayoutMainProps {
	children: React.ReactNode;
}

const LayoutMain: React.FC<LayoutMainProps> = ({ children }) => {
	const { isLogged } = useContext(LoginContext);

	return isLogged ? (
		<S.container>
			<Navbar />

			<S.titleNavAndContent>
				<NavTitleBar />
				{children}
			</S.titleNavAndContent>
		</S.container>
	) : (
		<>{children}</>
	);
};

export default LayoutMain;
